import React from 'react';
import Input from '../../forms/Input';
import SelectField from '../../forms/SelectField';
import { toDisplayString } from '../../../lib/date.utils';
import Checkbox from '../../forms/Checkbox';

const StageInputs = ({ onInput, data, staticData }) => (
    <React.Fragment>
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Input
                    regex={/^[0-9]\d*/}
                    onChange={onInput}
                    value={data.number}
                    label="Stage ID Number (order)"
                    name="number"
                />
            </div>
            <div className="ckp-admin-grid-column">
                <SelectField
                    label="Dates"
                    name="dates"
                    onChange={onInput}
                    value={data.dates}
                    multiple={true}
                    items={staticData.dates}
                />
            </div>
        </div>
        {data.dates.sort().map(x => (
            <div key={`name${x}`} className="ckp-admin-grid-row is-wrap">
                <div className="ckp-admin-grid-column">
                    <Input
                        onChange={onInput}
                        value={data[`name${x}`] || ''}
                        label={`Stage name ${toDisplayString(x, false)}`}
                        name={`name${x}`}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <Checkbox
                        className={'u-margin-top-2'}
                        name={`hidden${x}`}
                        checked={!data[`hidden${x}`]}
                        onChange={() => onInput(!data[`hidden${x}`], `hidden${x}`)}
                        label={'Visible for media partners'}
                    />
                </div>
            </div>
        ))}
    </React.Fragment>
);

export default StageInputs;
